// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, Skeleton } from '@mui/material';

// BillingPlanDrawerSkeleton renders the placeholder body shown while
// the drawer's line item is still resolving. The five blocks
// approximate the section heights of the loaded form (Pricing,
// ChargeSchedule, InvoiceSchedule, Activation, ChargeList) so the
// layout shift on resolution stays minimal.
export function BillingPlanDrawerSkeleton() {
  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Skeleton variant="rounded" height={120} />
      <Skeleton variant="rounded" height={180} />
      <Skeleton variant="rounded" height={140} />
      <Skeleton variant="rounded" height={100} />
      <Skeleton variant="rounded" height={240} />
    </Box>
  );
}
